module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0014.jpg?v=aa0065bc";